import {Component, EventEmitter, inject,  OnInit, Output} from '@angular/core';
import {catchError, map, tap} from 'rxjs/operators';
import {Observable, of } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import {CommonModule, DatePipe, NgOptimizedImage} from '@angular/common';

import {ApiService} from '@services/api.service';

import {TruncatePipe} from '../../truncate.pipe';
import {PaginationComponent} from '@components/pagination/pagination.component';
import {SearchPanelComponent} from '@components/search-panel/search-panel.component';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {DocumentType, IdLabel, RequestMailItem, RequestMailListResponse, TypeResponse} from '../../models/output.model';
import {SearchConfigRequest} from '../../models/search-config.model';
import {HRRequestListInput} from '../../models/input.model';
import {UtilsService} from '@services/utils.service';


@Component({
  selector: 'app-my-requests',
  imports: [CommonModule, HttpClientModule, DatePipe, TruncatePipe, PaginationComponent, SearchPanelComponent, RouterLink, RouterLinkActive, NgOptimizedImage],
  templateUrl: './my-requests.component.html',
  styleUrl: './my-requests.component.css',
  standalone: true,
})

export class MyRequestsComponent implements OnInit {

  @Output() navigate = new EventEmitter<string>();

  requests$!: Observable<RequestMailItem[]>;
  totalRows: number = 0;

  searchPanelConfig: SearchConfigRequest[] = [
    {key: 'state', label: 'Stato', type: 'select',
      options: [
        {label: 'Bozza', value: 'draft'},
        {label: 'Da lavorare', value: 'to_do'},
        {label: 'Aperta', value: 'taking_charge'},
        {label:'In Lavorazione', value: 'in_progress'},
        {label:'Integrazione Necessaria', value: 'integration_required'},
        {label:'Pronta alla chiusura', value: 'ready_to_close'},
        {label:'Rifiutata', value: 'rejected'},
        {label:'Chiusa', value: 'closed'}
      ]},
    {key: 'request_type_id', label: 'Richiesta', type: 'select', options: []},
    {key: 'code', label: 'Codice', type: 'text'},
    {key: 'date_from', label: 'Dal', type: 'date'},
    {key: 'date_to', label: 'Al', type: 'date'},
  ]
  pagingParams!: {offset: number, limit: number};
  currentSort: {
    field: string; order: 'asc' | 'desc' } = {
    field: 'date',
    order: 'desc',
  }


  currentFilters:  HRRequestListInput | {} = {}
  utilsSvc = inject(UtilsService)
  constructor(
    private router: Router,
    private apiService: ApiService
  ) {
  }

  ngOnInit(): void {
    this.pagingParams = this.utilsSvc.pagination
    this.currentSort = {... this.currentSort, ...this.pagingParams};
    this.fetchRequests(this.currentSort);
    this.fetchUserRequestTypes();
  }
  refresh(): void {
    this.pagingParams = {...this.utilsSvc.pagination, ...{offset:0}}
    this.currentFilters = {...this.currentFilters, ...this.currentSort , ...{offset:0} }
    this.fetchRequests(this.currentFilters);
  }
  onRowClicked(id: string) {
    this.router.navigate(['/richiesta', id]);
  }

  fetchRequests(params: HRRequestListInput | {}) {

    params = {
      ...params,
      order: this.currentSort.order,
      order_field: this.currentSort.field
    }
    this.requests$ = this.apiService.getRequests( params).pipe(
      map((response: RequestMailListResponse) => {
        if (response.result?.status != 'error')
        {
          this.totalRows = response.result.total_row
          return response.result.data;
        } else {
          return []
        }
      }),
      catchError(error => {
        console.error("Errore nel recupero delle richieste", error);
        return of([])
      })
    )
  }

  fetchUserRequestTypes(): void {
    const typeConfig = this.searchPanelConfig.find((config: SearchConfigRequest) => config.key === 'request_type_id')
    if (typeConfig) {
      this.apiService.getUserRequestTypes().pipe(
        map((response: TypeResponse) => response.data.sort((a: IdLabel, b: IdLabel) => a.label.localeCompare(b.label))),
        catchError(error => {
          console.error("Errore nel recupero dei types", error);
          return of([])
        })
      ).subscribe({
        next: (types: DocumentType[]) => {
          typeConfig.options = types.map((item: IdLabel) => {
            return {
              label: item.label,
              value: item.id + ""
            };
          });
        },
        error: error => {
          console.error("Errore nel recupero dei types", error);
        }
      })
    }
  }


  goToPage(page: HRRequestListInput) {
    this.currentFilters = {...this.currentFilters ,...this.currentSort , ...page}
    this.onSearchParamChange(page )
  }

  onSearchParamChange(params: HRRequestListInput): void  {
    if(params == null || Object.keys(params).length === 0) {
      this.currentFilters = { ...this.currentSort }
    } else {
      this.currentFilters = {...this.currentFilters, ...this.currentSort , ...params}
    }
    this.fetchRequests(this.currentFilters);
  }

  setOrder(field: string) {
    if (this.currentSort.field === field) {
      this.currentSort.order = this.currentSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSort.field = field;
      this.currentSort.order = 'asc'
    }
    this.fetchRequests(this.currentFilters)
  }

  getBadgeClass(stato: string) {
    return {
      'bg-[#80a6da] text-white': stato === 'in_progress' || stato === 'ready_to_close',// || stato === 'taking_charge',
      'bg-green-100 text-green-700 border border-green-200': stato === 'closed', //ok
      'bg-red-100 text-red-700 border border-red-200': stato === 'rejected', //ok
      'bg-white': stato === 'to_do' || stato === 'draft',
      'bg-white border-[1px] border-blue-100': stato === 'to_do' || stato === 'draft' || stato === 'taking_charge',
      'bg-yellow-100 border border-yellow-200': stato === 'integration_required'
    };
  }
}
